// Created by hejikun on 2017/11/2 0002.
import test from '../../test/index' // 这是一个测试页面，用于做一些功能测试，勿删
let app = [
  {
    path: '/',
    name: '滇医通',
    component: () => import('@/pages/index')
  },
  {
    path: '/home',
    name: '滇医通',
    component: () => import('@/pages/home/index')
  },
  {
    path: '/special-zone-list',
    name: '全部专区',
    component: () => import('@/pages/home/special-zone-list')
  },
  {
    path: '/home_new',
    name: '滇医通',
    component: () => import('@/pages/home/index_new')
  },
  {
    path: '/platIndex',
    name: '滇医通',
    component: () => import('@/pages/home/platIndex')
  },
  {
    path: '/lead_attention',
    name: '关注滇医通',
    component: () => import('@/pages/lead_attention')
  },
  {
    path: '/new_attention',
    name: '关注滇医通',
    component: () => import('@/pages/new_attention')
  },
  {
    path: '/new_attention2',
    name: '关注滇医通',
    component: () => import('@/pages/new_attention2')
  },
  {
    path: '/bind_mobile',
    name: '绑定手机号',
    component: () => import('@/pages/bind_mobile')
  },
  {
    path: '/test',
    name: '测试页',
    components: {
      default: test
    }
  },
  {
    path: '/source_index',
    name: '滇医通',
    component: () => import('@/pages/source_index')
  },
  {
    path: '*',
    name: '滇医通',
    component: () => import('@/pages/404')
  },
  {
    path: '/test_page',
    name: '数字健康管理系统',
    component: () => import('@/pages/test')
  },
  {
    path: '/searchIndex',
    name: '搜索',
    component: () => import('@/pages/home/searchIndex')
  }
]

export default app
